import { useMutation, useQuery } from "@tanstack/react-query";
import { UpdateMerchantTemplateCommand } from "@/models/club";
import merchantService from ".";

const useUpdateMerchantProfileImage = () => {
  return useMutation({
    mutationFn: merchantService.updateMerchantProfileImage,
  });
};

const useGetMerchantForMerchantUser = (mobileNumber: string) => {
  return useQuery({
    queryKey: ["getMerchantForMerchantUser", mobileNumber],
    queryFn: () => merchantService.getMerchantForMerchantUser(mobileNumber),
  });
};

const useUpdateMerchantTemplate = () =>
  useMutation({
    mutationFn: (command: UpdateMerchantTemplateCommand) =>
      merchantService.updateMerchantTemplate(command),
  });

export {
  useUpdateMerchantProfileImage,
  useGetMerchantForMerchantUser,
  useUpdateMerchantTemplate,
};
